import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API, withCredentials: true });

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
}

export const pdfUrl = (cf, tipo) => `${API}/public/condomini/${encodeURIComponent(cf)}/documenti/${tipo}/pdf`;

export const BRAND = "Nenyre Servizi";
export const SUPPORT_EMAIL = "info@nenyreservizi.it";
